<style scoped lang="scss">
  .achievement{
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    li{
      width:26%;
      text-align: center;
      margin-bottom: 40px;
      .img-box{
        /*padding:20px 0;*/
        border: 1px solid #E4E6EA;
        margin-bottom: 15px;
        img{
          width:100%;
          //height:250px;
          //display: block;
          //font-size: 0;
        }
      }
      &:nth-of-type(4),
      &:nth-of-type(5),
      &:nth-of-type(6){
        .img-box{
          img{
            height:440px;
          }
        }
      }
    }
  }
</style>
<style scoped>
@media screen and (max-width: 641px){
  .breads{
    display: none!important;
  }
}
@media
screen and (max-width: 375px) and (min-width: 374px),
screen and (max-width: 414px) and (min-width: 413px),
screen and (max-width: 640px) and (min-width: 600px),
screen and (min-width: 300px) and (max-width:400px)
{
  .achievement{
    display: block!important;
    width: 90% !important;
    margin-left: auto;
    margin-right: auto;
  }
}
@media screen and (max-width: 640px){
  .container{
    width: 100% !important;
    font-size: 12px!important;
    text-align: justify;
    padding-left: 15px;
    padding-right: 15px;
  }
  .c-title{
    padding: 20px 0 20px!important;
    font-size: 18px!important;
  }
  .achievement li {
    width: 100% !important;
  }
}
</style>
<template>
  <div>
    <div class="breads container" style="overflow:auto;line-height: 48px;padding-left: 10px;margin-bottom:  20px;margin-top: 20px;">
      <bread></bread>
    </div>
    <div class="c-title">发展成果</div>
    <div class="container">
      <ul class="achievement">
        <li v-for="(item, index) in achieveLists" :key="index">
          <div class="img-box">
            <img :src="`/static/img/acth_${index+1}.png`">
          </div>
          <p>{{item}}</p>
        </li>
      </ul>
      <ul class="achievement">
        <li v-for="(item, index) in achieveLists1" :key="index">
          <div class="img-box">
            <img :src="`/static/img/acth1_${index+1}.png`">
          </div>
          <p>{{item}}</p>
        </li>
      </ul>
<!--      <ul class="achievement">-->
<!--        <li v-for="(item, index) in achieveLists2" :key="index" style="width: -moz-fit-content;
width: fit-content; margin-left: auto;margin-right: auto;">-->
<!--          <div class="img-box">-->
<!--            <img :src="`/static/img/acth2_${index+1}.png`">-->
<!--          </div>-->
<!--          <p>{{item}}</p>-->
<!--        </li>-->
<!--      </ul>-->
      <div v-for="(item, index) in achieveLists2" :key="index">
        <div class="img-box" style="width: 100%;">
          <img :src="`/static/img/acth2_${index+1}.png`" width="100%">
        </div>
        <p style="text-align: center">{{item}}</p>
      </div>
    </div>
  </div>
</template>

<script>
import bread from "@/components/bread"
export default {
  components:{
    bread
  },
  data () {
    return {
      achieveLists: [ '博士后科研工作站', '北京企业技术中心证书', '2020德勤-中国高科技高成长50强证书', ],       //'知识产权试点单位证书',
      achieveLists1: [ '北京市青年突击队证书','北京市知识产权示范单位', '2020年北京民营企业中小百强证书'],
      achieveLists2: ['质量三新产权证书']
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/summary/achievement.vue